<div class="dsr-main-container">
    <mat-card oneCard class="dsr-one-card">
        <mat-card-title style="display: flex; flex-direction: column; margin-bottom: 1rem;">
            <span class="mat-title">Enable Daily Summary Report</span>
            <mat-slide-toggle [(ngModel)]="isDailySummaryEnabled" style="font-size: 16px;" (change)="toggleEnable($event.checked)">
                Enabled
            </mat-slide-toggle>
        </mat-card-title>
        <mat-card-content *ngIf="isDailySummaryEnabled">
            <div class="dsr-content-section">
                <h4 style="margin-top: 30px;">Include in report:</h4>
                <div class="dsr-checkbox-group">
                    <mat-checkbox *ngFor ="let options of reportContent" [checked]="selected.has(options)" class="dsr-individual-checkbox" (change)="contentSelection(options, $event.checked)">{{options}}</mat-checkbox>
                    <mat-checkbox class="dsr-individual-checkbox" [checked]="isAllSelected()" (change)="contentAllSelection($event.checked)">All</mat-checkbox>
                </div>
                <div class="dsr-send-report-section">
                    <h4 style="margin-top: 30px;">Send report to:</h4>
                    <input class="dsr-sendto-input" [formControl]="sendToControl">
                    <div *ngIf="emailRequired || invalidEmail" class="error">
                        <mat-error style ="margin-left:10px" *ngIf="emailRequired">Email is required.</mat-error>
                        <mat-error style ="margin-left:10px" *ngIf="invalidEmail">Please enter a valid email address.</mat-error>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
